<h3 class="h3-xs mt-4">Job details</h3>
@if (!job) {
  <div class="fst-italic text-smaller">Select job to see details</div>
}

@if (job) {
  <div>
    <div class="border p-3 pb-0" style="background-color: white">
      <table class="table table-sm text-sm align-top mb-0">
        <tbody>
          <tr>
            <td class="lighter">Tool:</td>
            <td class="wide-max" width="100%">{{ job.toolCategory + " / " + job.toolName }}</td>
          </tr>

          <tr>
            <td class="lighter">Status:</td>
            <td class="wide-max">
              {{ state }}
              @if (isRunning && job.stateDetail) {
                <span>- {{ job.stateDetail }}</span>
              }
              @if (isRunning) {
                <button class="btn btn-sm btn-link" (click)="cancelJob()">Cancel</button>
              }
            </td>
          </tr>
          <tr>
            <td class="lighter">Created:</td>
            <td class="wide-max" width="100%">{{ job.created | localDate }}</td>
          </tr>
          <tr>
            <td class="lighter">Started:</td>
            <td class="wide-max" width="100%">{{ job.startTime | localDate }}</td>
          </tr>
          <tr>
            <td class="lighter">Ended:</td>
            <td>{{ job.endTime | localDate }}</td>
          </tr>

          @if (duration != null) {
            <tr>
              <td class="lighter">Duration:</td>
              <td>{{ duration | async }}</td>
            </tr>
          }

          <tr>
            <td class="lighter" style="white-space: nowrap">Memory usage:</td>
            <td>{{ job.memoryUsage | bytes: 0 }} / {{ job.memoryLimit | bytes: 0 }}</td>
          </tr>

          <tr>
            <td class="lighter" style="white-space: nowrap">Storage usage:</td>
            <td>{{ job.storageUsage | bytes: 0 }} / {{ job.storageLimit | bytes: 0 }}</td>
          </tr>

          @if (failed) {
            <tr>
              <td class="lighter" style="white-space: nowrap">Error message:</td>
              <td class="wide-max">
                @if (job.stateDetail) {
                  <pre>{{ job.stateDetail }}</pre>
                }
              </td>
            </tr>
          }

          <tr>
            <td class="lighter">Parameters:</td>
            <td class="ps-0">
              <ch-dataset-parameter-list
                [parameters]="parameterListForView"
                [parametersLimit]="-1"
                [tool]="tool"></ch-dataset-parameter-list>
            </td>
          </tr>

          <tr>
            <td class="lighter">Input files:</td>
            <td class="table-td">
              <table class="table table-sm mb-0">
                <tbody>
                  @for (input of inputListForView; track input.inputId) {
                    <tr>
                      <td style="width: 60%; white-space: nowrap">
                        {{ input.displayName || input.inputId }}
                      </td>

                      @if (hasDataset(input.datasetId)) {
                        <td>
                          <ch-link-button class="no-underline-link-button" (click)="selectDataset(input.datasetId)">
                            {{ getDatasetName(input.datasetId) }}
                          </ch-link-button>
                        </td>
                      }
                      @if (!hasDataset(input.datasetId)) {
                        <td>(deleted)</td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="lighter">Result files:</td>
            <td class="table-td">
              <table class="table table-sm mb-0">
                <tbody>
                  @for (output of outputListForView; track output.outputId || output.datasetId) {
                    <tr>
                      <td style="width: 60%; white-space: nowrap">
                        {{ output.displayName || output.outputId }}
                      </td>

                      @if (hasDataset(output.datasetId)) {
                        <td>
                          <ch-link-button class="no-underline-link-button" (click)="selectDataset(output.datasetId)">
                            {{ getDatasetName(output.datasetId) }}
                          </ch-link-button>
                        </td>
                      }
                      @if (!hasDataset(output.datasetId)) {
                        <td>(deleted)</td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td class="lighter text-nowrap">Application versions:</td>
            <td class="p-0">
              <table class="table table-sm">
                <tbody>
                  @for (appVersion of applicationVersions; track appVersion.application) {
                    <tr>
                      @if (appVersion.application !== "R Session Info") {
                        <td class="label-td">
                          {{ appVersion.application }}
                        </td>
                      }
                      @if (appVersion.application !== "R" && appVersion.application !== "R Session Info") {
                        <td>
                          <pre class="m-0">{{ appVersion.version }}</pre>
                        </td>
                      }
                      @if (appVersion.application === "R") {
                        <td>
                          <pre class="d-inline m-0">{{ appVersion.version }}</pre>
                          <span>
                            <ch-link-button class="no-underline-link-button ms-2" (click)="toggleRSessionInfo()">
                              @if (rSessionInfoVisible) {
                                <span>Hide</span>
                              } @else {
                                <span>Show</span>
                              }
                              R session info
                            </ch-link-button>
                          </span>

                          @if (rSessionInfoVisible) {
                            <pre class="mt-2">{{ rSessionInfo }}</pre>
                          }
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-1 mt-4 d-flex justify-content-between align-items-center">
      <h3 class="h3-xs mb-0">Screen Output</h3>
      @if (isRTool && hasInputLines) {
        <button class="btn btn-sm btn-secondary" (click)="toggleInputLines()">
          {{ hideInputLines ? "Show input lines" : "Hide input lines" }}
        </button>
      }
    </div>

    <div class="text-sm bg-white border container">
      <pre style="margin-bottom: 0em">{{ filteredScreenOutput }}</pre>
      @if (isRunning) {
        <i class="fas fa-circle-notch fa-spin fa-fw"></i>
      }
    </div>
  </div>
}
